import { render, staticRenderFns } from "./form-organizations-on-sign-callback.vue?vue&type=template&id=a74eaef0&scoped=true&lang=pug"
import script from "./form-organizations-on-sign-callback.vue?vue&type=script&lang=js"
export * from "./form-organizations-on-sign-callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74eaef0",
  null
  
)

export default component.exports